<template>
  <div style="padding: 15px;background: #fff;">
    <!-- 工具栏 -->
    <div class="table-page-search-wrapper" style="margin-bottom:10px;">
      <a-form layout="inline">
        <a-form-item>
          <a-range-picker
            :disabledDate="disabledDate"
            :value="dateTimeRange"
            format="YYYY-MM-DD"
            @change="onChangeDatePicker"
          />
        </a-form-item>
        <a-form-item>
          <a-select
            :value="feedbackType"
            @change="handleDepartment"
            style="width:150px"
          >
            <a-select-option value="">反馈类型-全部</a-select-option>
            <a-select-option
              v-for="item in feedbackTypeList"
              :key="item"
              :value="item"
              >{{ item }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select
            :value="anonymous"
            @change="handleAnonymous"
            style="width:150px"
          >
            <a-select-option value="">是否匿名-全部</a-select-option>
            <a-select-option value="0">匿名</a-select-option>
            <a-select-option value="1">实名</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" style="margin-left: 10px;" @click="search">
            <a-icon type="search" />
            查询
          </a-button>
          &emsp;
        </a-form-item>
      </a-form>
    </div>
    <!-- 表格 -->
    <a-table
      :columns="tableColumns"
      :dataSource="tableData"
      bordered
      :pagination="pagination"
      :loading="tableLoading"
      size="small"
    >
      <span slot="feedbackType" slot-scope="item">
        <a-tag :color="filterColor(item)">{{ item }}</a-tag>
      </span>
      <!-- 操作 -->
      <span slot="action" slot-scope="item">
        <a href="javascript:;" @click="delItem(item)">删除</a>
      </span>
    </a-table>
  </div>
</template>
<script>
import moment from 'moment'
import { getFeedbackList, getFeedbackTypeList, delFeedback } from '@/apis/feedback';

let colorList = ["orange", "green", "cyan", "blue", "purple"]

const tableColumns = [
  {
    title: '时间',
    dataIndex: 'feedbackTime',
    key: 'feedbackTime',
    width: 160,
    align: 'center'
  },
  {
    title: '员工姓名',
    dataIndex: 'workerName',
    key: 'workerName',
    width: 80,
    align: 'center'
  },
  {
    title: '反馈类型',
    dataIndex: 'feedbackType',
    key: 'feedbackType',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'feedbackType' }
  },
  {
    title: '反馈内容',
    dataIndex: 'content',
    key: 'content'
  }, {
    title: '操作',
    key: 'action',
    width: 70,
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  data() {
    return {
      feedbackType: '',
      dateTimeRange: [],
      anonymous: '',
      feedbackTypeList: [],
      tableData: [],
      tableColumns,
      pagination: {
        onChange: (page, pageSize) => {
          this.pagination.current = page;
          this.pagination.pageSize = pageSize;
          this._getFeedbackList();
        },
        total: 0,
        pageSize: 12,
        current: 1,
        size: 'middle',
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['12', '24', '36', '48'],
        defaultPageSize: 12,
        showSizeChanger: true,
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize;
          this.pagination.current = 1;
          this._getFeedbackList();
        }
      },
      tableLoading: false
    };
  },
  methods: {
    filterColor(item) {
      let tempIndex = 0
      const len = this.feedbackTypeList.length
      tempIndex = this.feedbackTypeList.findIndex(data => data === item)
      return colorList[(tempIndex + 1) % len]
    },
    // 选择反馈类型
    handleDepartment(value) {
      this.feedbackType = value
    },
    onChangeDatePicker(date, dateString) {
      this.dateTimeRange = date
    },
    // 日期选择器
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    handleAnonymous(value) {
      this.anonymous = value
    },
    search() {
      this.pagination.current = 1;
      this._getFeedbackList();
    },
    // 获取数据
    _getFeedbackList() {
      this.tableLoading = true;
      getFeedbackList({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        feedbackType: this.feedbackType,
        start: this.dateTimeRange.length ? this.dateTimeRange[0].format('YYYY-MM-DD') : '',
        end: this.dateTimeRange.length ? this.dateTimeRange[1].format('YYYY-MM-DD') : '',
        isAnonymous: this.anonymous ? this.anonymous === '0' : ''


      }).then(res => {
        const result = res.data.attribute;
        this.tableLoading = false;
        this.pagination.total = result.count;
        let tempData = []
        tempData = result.rows.map(item => ({
          key: item.id,
          feedbackType: item.feedbackType,
          content: item.content,
          isAnonymous: item.isAnonymous,
          workerName: item.workerName,
          feedbackTime: item.feedbackTime.split('T')[0] + ' ' + item.feedbackTime.split('T')[1].split('.')[0]
        }))


        this.tableData = tempData
      },
        res => {
          this.tableLoading = false;
        });
    },
    delItem(item) {
      let that = this;
      that.$confirm({
        title: '您确定要删除这条反馈吗？',
        content: '删除后不可撤销！',
        onOk() {
          delFeedback({
            id: item.key
          }).then(res => {
            if (res.data.state === 1) {
              that.$message.success('删除成功');
              that.search()
            }
          })
        }
      });
    },
    // 获取反馈类型下拉
    _getFeedbackTypeList() {
      getFeedbackTypeList().then(res => {
        this.feedbackTypeList = res.data.attribute
      })
    }
  },
  created() {
    this._getFeedbackList();
  },
  mounted() {
    this._getFeedbackTypeList()
  }
};
</script>

<style lang="less" scoped></style>

<style lang="less">
// 覆盖antd样式
.ant-table-small
  > .ant-table-content
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th {
  background: #fafafa !important;
}

.ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0 !important;
}
</style>
